import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MappingService } from 'app/core/services/mapping.service';
import tinymce from 'tinymce';

@Component({
  selector: 'spintax-dialog',
  templateUrl: './spintax-dialog.component.html',
  styleUrls: []
})
export class SpintaxDialogComponent implements OnInit{
  constructor(private _dialog: MatDialog, public _mapping: MappingService) {

  }

  ngOnInit(): void {

  }

  addVariant() {
    this._mapping.inputs.push({
      label: 'CAMPAIGN.VARIANT',
      hint_text: '',
      value: '',
    })
  }

  doAddSpinTax() {
    const values = this._mapping.inputs.map(input => input.value).filter(value => value.trim() != '');
    if (values.length > 0) {
      const spintaxText = `{{RANDOM | ${values.join(' | ')}}}`;
      const editor = tinymce.activeEditor;
      const spanContent = `<span class="spintaxEditable" data-mce-content="${spintaxText}" contenteditable="true" data-mce-selected="1">${spintaxText}</span>`;
      editor.insertContent(spanContent);
      console.log(spanContent);
    }
    this._dialog.closeAll();
  }
}
